import React, { Component } from "react";
import siteConfig from "../../data/SiteConfig.js";

import Technologies from "./About/Technologies.jsx";

/** @jsx jsx */
import { Styled, jsx } from "theme-ui";

class About extends Component {
  render() {
    const { avatar } = siteConfig;
    return (
      <div
        sx={{
          display: "grid",
          height: "100%",
          margin: "auto",
          justifyItems: "center",
          textAlign: "center"
        }}
      >
        <img src={avatar.photo} sx={{borderRadius: 200}}/>
        <h1>Geraldyluz Amezcua Cobián</h1>
        <p>Software developer focused on Full stack development, real-time, concurrency and emergent tech</p>

        <Technologies />
      </div>
    );
  }
}

export default About;
